/*
 *
 * ApmConfigurationModal
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 14-Jan-2025
 */

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ApmConfigurationModal from './ApmConfigurationModal'
import { doPopup } from 'Store/actions/popup'
import * as terminalsManagementActions from '../../routes/TerminalsManagement/modules/TerminalsManagementActions'
import { getApmList, getPaypalPayIn3 } from 'Store/selectors'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(terminalsManagementActions, dispatch),
  togglePopup: (popup, moreInfo) => dispatch(doPopup(popup, moreInfo))
})

const mapStateToProps = (state) => ({
  apmId: state.TerminalsManagement?.selectedApmId,
  apmList: getApmList(state),
  paypalPayIn3: getPaypalPayIn3(state),
  loadingList: state?.loading?.local_terminalApmList || false,
  loadingApm: state?.loading?.local_terminalUpdateApm || state?.loading?.local_terminalGetPaypalExternalLink || false
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ApmConfigurationModal)
